import { render } from "./AudienceStats.vue?vue&type=template&id=4ae29452&scoped=true"
import script from "./AudienceStats.vue?vue&type=script&lang=js"
export * from "./AudienceStats.vue?vue&type=script&lang=js"

import "./AudienceStats.vue?vue&type=style&index=0&id=4ae29452&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae29452"]])

export default __exports__